import { TChestVariant } from '../../../types';

import GalaxyShine from '../../../assets/images/chests/shines/galaxy-shine-bg.png';
import LaunchShine from '../../../assets/images/chests/shines/launch-shine-bg.png';
import OrbitShine from '../../../assets/images/chests/shines/orbit-shine-bg.png';
import SupernovaShine from '../../../assets/images/chests/shines/supernova-shine-bg.png';

export const getShineBg = (variant: TChestVariant) => {
  switch (variant) {
    case 'launch':
      return LaunchShine;
    case 'orbit':
      return OrbitShine;
    case 'galaxy':
      return GalaxyShine;
    case 'supernova':
      return SupernovaShine;
    default:
      return LaunchShine;
  }
};
